import React, { memo } from "react";
import { makeStyles } from "@material-ui/styles";
import Chip from "@material-ui/core/Chip";

import palette from "../../styles/palette";

const useStyles = makeStyles(({ typography }) => ({
  criteriaItem: {
    margin: `${typography.pxToRem(3)} ${typography.pxToRem(8)}`,
    background: palette.typography.white.solid,
    height: typography.pxToRem(22),
    "&:hover, &:focus": {
      backgroundColor: palette.typography.white.solid,
    },
  },
}));

const SelectedCriteriaItem = memo(
  ({ label, handleDelete, handleClick, avatar, id }) => {
    const classes = useStyles();

    return (
      <Chip
        className={classes.criteriaItem}
        size="small"
        label={label}
        avatar={avatar}
        onDelete={handleDelete}
        onClick={handleClick}
        key={id}
      />
    );
  }
);

export default SelectedCriteriaItem;
